/**
 * Peintio Footer JavaScript
 * Handles mobile menu toggling and interactive elements
 */
document.addEventListener('DOMContentLoaded', () => {
  // Mobile functionality for footer columns
  const setupFooter = () => {
    const isMobile = window.innerWidth < 768;
    const footerColumnTitles = document.querySelectorAll('.footer-column-title');
    
    // Clear any existing event listeners
    footerColumnTitles.forEach(title => {
      const oldTitle = title.cloneNode(true);
      title.parentNode.replaceChild(oldTitle, title);
    });
    
    if (isMobile) {
      // Setup accordion functionality for mobile
      document.querySelectorAll('.footer-column-title').forEach(title => {
        // Add toggle indicator if not already added
        if (!title.querySelector('.toggle-indicator')) {
          const indicator = document.createElement('span');
          indicator.classList.add('toggle-indicator');
          indicator.innerHTML = '+';
          indicator.style.position = 'absolute';
          indicator.style.right = '10px';
          indicator.style.top = '10px';
          indicator.style.fontSize = '18px';
          indicator.style.fontWeight = 'bold';
          title.style.position = 'relative';
          title.appendChild(indicator);
        }
        
        // Set up collapsible content
        setupCollapsibleContent(title);
        
        // Add click event for toggling
        title.addEventListener('click', function() {
          toggleSection(this);
        });
      });
    } else {
      // Reset all desktop styles
      document.querySelectorAll('.footer-column-title').forEach(title => {
        // Remove toggle indicators for desktop
        const indicator = title.querySelector('.toggle-indicator');
        if (indicator) {
          indicator.remove();
        }
        
        // Restore visibility
        resetSection(title);
      });
    }
  };
  
  // Set up each collapsible content section
  const setupCollapsibleContent = (title) => {
    if (title.textContent.includes('JOIN OUR COMMUNITY')) {
      // Special handling for newsletter section
      const newsletterText = title.nextElementSibling;
      const newsletterForm = newsletterText ? newsletterText.nextElementSibling : null;
      
      // Initially collapse newsletter content
      if (newsletterText) {
        collapseElement(newsletterText);
      }
      
      if (newsletterForm) {
        collapseElement(newsletterForm);
      }
    } else {
      // Regular menu handling
      const menu = title.nextElementSibling;
      if (menu && menu.classList.contains('footer-menu')) {
        collapseElement(menu);
      }
    }
  };
  
  // Toggle section visibility
  const toggleSection = (title) => {
    const indicator = title.querySelector('.toggle-indicator');
    
    if (title.textContent.includes('JOIN OUR COMMUNITY')) {
      // Handle newsletter section toggle
      const newsletterText = title.nextElementSibling;
      const newsletterForm = newsletterText ? newsletterText.nextElementSibling : null;
      
      if (title.classList.contains('active')) {
        // Collapse
        title.classList.remove('active');
        if (indicator) indicator.innerHTML = '+';
        
        if (newsletterText) collapseElement(newsletterText);
        if (newsletterForm) collapseElement(newsletterForm);
      } else {
        // Expand
        title.classList.add('active');
        if (indicator) indicator.innerHTML = '−';
        
        if (newsletterText) expandElement(newsletterText);
        if (newsletterForm) expandElement(newsletterForm);
      }
    } else {
      // Handle regular menu toggle
      const menu = title.nextElementSibling;
      
      if (title.classList.contains('active')) {
        // Collapse
        title.classList.remove('active');
        if (indicator) indicator.innerHTML = '+';
        
        if (menu) collapseElement(menu);
      } else {
        // Expand
        title.classList.add('active');
        if (indicator) indicator.innerHTML = '−';
        
        if (menu) expandElement(menu);
      }
    }
  };
  
  // Helper function to collapse an element
  const collapseElement = (element) => {
    element.style.maxHeight = '0';
    element.style.opacity = '0';
    element.style.visibility = 'hidden';
    element.style.overflow = 'hidden';
    element.style.marginTop = '0';
    element.style.transition = 'max-height 0.3s ease, opacity 0.3s ease, visibility 0.3s ease, margin 0.3s ease';
  };
  
  // Helper function to expand an element
  const expandElement = (element) => {
    element.style.maxHeight = element.scrollHeight + 'px';
    element.style.opacity = '1';
    element.style.visibility = 'visible';
    element.style.overflow = 'visible';
    element.style.marginTop = '15px';
  };
  
  // Reset section to normal state (for desktop)
  const resetSection = (title) => {
    if (title.textContent.includes('JOIN OUR COMMUNITY')) {
      const newsletterText = title.nextElementSibling;
      const newsletterForm = newsletterText ? newsletterText.nextElementSibling : null;
      
      title.classList.remove('active');
      
      if (newsletterText) {
        resetElementStyles(newsletterText);
      }
      
      if (newsletterForm) {
        resetElementStyles(newsletterForm);
      }
    } else {
      const menu = title.nextElementSibling;
      
      title.classList.remove('active');
      
      if (menu) {
        resetElementStyles(menu);
      }
    }
  };
  
  // Helper function to reset element styles
  const resetElementStyles = (element) => {
    element.style.maxHeight = '';
    element.style.opacity = '';
    element.style.visibility = '';
    element.style.overflow = '';
    element.style.marginTop = '';
    element.style.transition = '';
  };
  
  // Style Klaviyo Form
  const styleKlaviyoForm = () => {
    const klaviyoForm = document.getElementById('klaviyo-form-YjdgfC');
    if (klaviyoForm) {
      // Add styles to ensure form fits and has correct text color
      const styleKlaviyoElements = () => {
        // Find all inputs and style them
        const inputs = klaviyoForm.querySelectorAll('input');
        inputs.forEach(input => {
          input.style.color = '#8c3c30';
        });
        
        // Find all labels and style them
        const labels = klaviyoForm.querySelectorAll('label');
        labels.forEach(label => {
          label.style.color = '#8c3c30';
        });
        
        // Style submit buttons
        const buttons = klaviyoForm.querySelectorAll('button');
        buttons.forEach(button => {
          if (button.type === 'submit' || button.classList.contains('klaviyo-form-submit-button')) {
            button.style.width = '100%';
            button.style.backgroundColor = '#1a1a1a';
            button.style.color = '#fff';
            button.style.padding = '12px 15px';
            button.style.textTransform = 'uppercase';
            button.style.fontWeight = '600';
          }
        });
      };
      
      // Style immediately and after a delay to catch dynamic elements
      styleKlaviyoElements();
      setTimeout(styleKlaviyoElements, 1000);
      setTimeout(styleKlaviyoElements, 2000);
    }
  };
  
  // Initialize
  setupFooter();
  styleKlaviyoForm();
  
  // Watch for window resize
  window.addEventListener('resize', setupFooter);
  
  // Create a MutationObserver to detect when Klaviyo form gets loaded
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        if (document.getElementById('klaviyo-form-YjdgfC')) {
          styleKlaviyoForm();
          
          // Once found, we can disconnect the observer
          observer.disconnect();
          break;
        }
      }
    }
  });
  
  // Start observing the document with the configured parameters
  observer.observe(document.body, { childList: true, subtree: true });
});